import React from "react";

import PropTypes from "prop-types";
import classnames from "classnames";

import OkInput from "shared/components/oknf/OkInput";

import "./Input.scss";

const Input = ({ name, label, children, className = "", ...rest }) => {
	return (
		<label
			className={classnames(className, {
				"payment-input": true,
			})}
			htmlFor={name}
		>
			<div
				className={classnames({
					"payment-input-label": true,
				})}
			>
				{label}
			</div>
			<OkInput
				name={name}
				className={classnames({
					"payment-input-text": true,
				})}
				id={name}
				{...rest}
			/>
			{children}
		</label>
	);
};

Input.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	className: PropTypes.string,
	children: PropTypes.node,
};

export default Input;



// WEBPACK FOOTER //
// ./src/apps/payment/components/Input/index.jsx